import { render, staticRenderFns } from "./shippingCard.vue?vue&type=template&id=7fc4554f&"
import script from "./shippingCard.vue?vue&type=script&lang=js&"
export * from "./shippingCard.vue?vue&type=script&lang=js&"
import style0 from "./shippingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports